export const PATIENTS_AGE_LIMITS = {
  MAX: 63,
  MAX_FOR_MEDICARE: 80,
  MIN: 18
};

export const RED_FLAGS = [
  'Chest pain',
  'Dizziness',
  'Blurry vision',
  'Lightheadedness',
  'Recent head injury',
  'Severe neck pain or stiffness',
  'Focal weakness in arm or legs',
  'Trouble speaking',
  'Syncope/passing out',
  'Shortness of breath',
  'Acute swelling of legs',
  'Heart palpitations',
  'Vomiting blood',
  'Bloody diarrhea',
  'Urinary symptoms with back/flank pain',
  'Urinary symptoms with fever',
  'Severe abdominal pain or tenderness',
  'Pelvic pain with fever or vaginal bleeding',
  'Significant trauma',
  'Alcohol/drug abuse',
  'Hallucinations (hearing voices, seeing things that are not seen by others)',
  'Any thoughts of harming self or others',
  'Acute scrotal pain',
  'Rash with a fever',
  'Pregnancy complications',
  'Seeking care for a work-related injury',
  'Seeking care for a car wreck/motor vehicle accident'
];

export const STATES_WHERE_BODY_PHOTO_IS_REQUIRED = ['Florida', 'New Jersey', 'Virginia'];

export const MAX_AVAILABLE_MH_MIF_POINTS = 16;
export const MAX_AVAILABLE_MH_MIF_POINTS_FOR_ON_DEMAND = 9;

export const MENTAL_HEALTH_MEDICATIONS = [
  {
    dosage: '5 mg',
    name: 'Sertraline',
    subtitle: 'Generic for Zoloft®',
    tags: ['pp-ins-sertraline', 'pp-sertraline-cash']
  },
  {
    dosage: '10 mg',
    name: 'Fluoxetine',
    subtitle: 'Generic for Prozac®',
    tags: ['pp-ins-fluoxetine', 'pp-fluoxetine-cash']
  },
  {
    dosage: '150 mg',
    name: 'Bupropion SR',
    subtitle: 'Generic for Wellbutrin XL®',
    tags: ['pp-ins-bupropion-sr', 'pp-bupropion-sr-cash']
  },
  {
    dosage: '20 mg',
    name: 'Citalopram',
    subtitle: 'Generic for Celexa®',
    tags: ['pp-ins-citalopram', 'pp-citalopram-cash']
  },
  {
    dosage: '30 mg',
    name: 'Duloxetine',
    subtitle: 'Generic for Cymbalta®',
    tags: ['pp-ins-duloxetine', 'pp-duloxetine-cash']
  },
  {
    dosage: '30 mg',
    name: 'Venlafaxine',
    subtitle: 'Generic for Effexor®',
    tags: ['pp-ins-venlafaxine', 'pp-venlafaxine-cash']
  },
  {
    dosage: '30 mg',
    name: 'Paroxetine',
    subtitle: 'Generic for Paxil®',
    tags: ['pp-ins-paroxetine', 'pp-paroxetine-cash']
  },
  {
    dosage: '30 mg',
    name: 'Propranolol',
    subtitle: 'Generic for Inderal®',
    tags: ['pp-ins-propranolol', 'pp-propranolol-cash']
  },
  {
    dosage: '30 mg',
    name: 'Escitalopram',
    subtitle: 'Generic for Lexapro®',
    tags: ['pp-ins-escitalopram', 'pp-escitalopram-cash']
  },
  {
    dosage: '30 mg',
    name: 'Buspirone HCI',
    subtitle: 'Generic for Buspar®',
    tags: ['pp-ins-buspirone-hci', 'pp-buspirone-hci-cash']
  }
];

export const REQUESTED_LAB_LIST = [
  'Make your appointment with Quest.',
  'Visit the lab and present a valid form of ID to get up to 95% savings.',
  'Complete your lab tests.',
  'Get notified in your LifeMD patient portal when your lab results are ready.',
  'Meet with your provider online to discuss your results.'
];

export const TT_LAB_STEPS = [
  'Make your appointment with Quest.',
  'Complete your lab tests. ',
  'Get notified in your LifeMD patient portal when your lab results are ready.'
];
